import { TopBar } from "@shopify/polaris";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { ContextUser } from "src/context/ContextUser";
import Cookies from "universal-cookie";
import { useToken } from "../authentication/TokenProvider";
import {
  ButtonMinor,
  CircleCancelMinor,
  CircleTickMinor,
  CustomersMinor,
  FavoriteMajor,
  LockMinor,
  LogOutMinor,
  FileFilledMinor,
} from "@shopify/polaris-icons";
import { useHistory } from "react-router-dom";
import { Modal } from "src/hooks/modal";
import { ChatMenuMarkup } from "./chat/ChatMenuMarkup";
import { NotificationMenuMarkup } from "./notification/NotificationMenuMarkup";
import { PopupLng } from "./PopupLng";
import { AnonouncementMenuMarkup } from "./notification/AnonouncementMenuMarkup";
import useWindowDimensions from "src/hooks/useWindow";

interface Props {
  toggleMobileNavigationActive?: () => void;
  open: boolean;
  setOpen: (e: boolean) => void;
}

export function TopBarMarkup({ toggleMobileNavigationActive, open, setOpen }: Props) {
  const { merchant } = useContext(ContextUser);
  const [userMenuActive, setUserMenuActive] = useState(false);
  const cookies = new Cookies();
  const context = useToken();
  const { push } = useHistory();
  const [passwordInput, setPasswordInput] = useState("");
  const { width } = useWindowDimensions();

  const toggleUserMenuActive = useCallback(() => setUserMenuActive((userMenuActive) => !userMenuActive), []);

  useEffect(() => {
    if (width < 1500) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [width, setOpen]);

  const menuProfile: any = [
    {
      content: "Edit Profile",
      icon: CustomersMinor,
      // onAction: () => push("/account/profile"),
      onAction: () => push("/seller/profile"),
    },
  ];

  const menuSecurity: any = [
    {
      content: "Reset Password Login",
      icon: LockMinor,
      onAction: () => push("/account/resetpassword"),
    },
  ];

  if (merchant && merchant.isMoreSecurity) {
    menuSecurity.push({
      content: "Reset Password Disbursement",
      icon: ButtonMinor,
      onAction: () => {
        push("/account/reset/password/disbursement");
      },
    });
  }

  const logout = () => {
    cookies.remove("lf_merchant_token");
    context.setToken(null);
    window.location.reload();
  };

  const handleClickMoreSecurity = () => {
    Modal.dialog({
      title: "More Security",
      body: (
        <div className="pl-3 pr-3 pb-4">
          <input
            type="password"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            className="form-control form-control-sm"
            placeholder="Enter password disbursement"
          />
        </div>
      ),
      buttons: [
        {
          title: "No",
          class: "danger",
        },
        {
          title: "Yes",
          class: "primary",
        },
      ],
    });
  };

  const userMenuMarkup = (
    <TopBar.UserMenu
      actions={[
        {
          items: [
            {
              content: merchant.isMoreSecurity ? "More Security On" : "More Security Off",
              icon: merchant.isMoreSecurity ? CircleTickMinor : CircleCancelMinor,
              onAction: handleClickMoreSecurity,
            },
          ],
        },
        {
          items: menuProfile,
        },
        {
          items: menuSecurity,
        },
        {
          items: [
            {
              content: "Terms Agreement",
              icon: FileFilledMinor,
              onAction: () => {
                window.open("/merchant/agreement", "_blank");
              },
            },
          ],
        },
        {
          items: [
            {
              content: merchant.supplier?.subscription
                ? `Subscription: ${merchant.supplier.subscription.planName}`
                : "Boost your sale",
              icon: FavoriteMajor,
              onAction: () => {
                push("/account/subscription");
              },
            },
          ],
        },
        {
          items: [
            {
              content: "Logout",
              icon: LogOutMinor,
              onAction: () => logout(),
            },
          ],
        },
      ]}
      name={merchant.name + ""}
      initials={merchant.name?.charAt(0).toUpperCase()}
      open={userMenuActive}
      onToggle={toggleUserMenuActive}
      avatar={merchant.logo + ""}
      detail={
        (
          <span style={{ textTransform: "capitalize", display: "flex", alignItems: "center" }}>
            {(merchant.role + "").toLowerCase()}{" "}
            {merchant.supplier?.subscription && (
              <div
                style={{
                  backgroundColor:
                    merchant.supplier.subscription.planName === "BOOST"
                      ? "rgb(239 68 68/1)"
                      : merchant.supplier.subscription.planName === "PRO"
                        ? "rgb(34 197 94/1)"
                        : "rgb(115 115 115/1)",
                  color: "rgb(255 255 255/1)",
                  borderRadius: "9999px",
                  textAlign: "center",
                  borderStyle: "dotted",
                  borderWidth: "0.025rem",
                  padding: "1px 3px",
                  marginLeft: 2,
                }}
              >
                {merchant.supplier?.subscription.planName}
              </div>
            )}
          </span>
        ) as any
      }
    />
  );

  const secondaryMenuMarkup = (
    <div style={{ display: "flex", alignItems: "center" }}>
      <PopupLng />
      <ChatMenuMarkup />
      <NotificationMenuMarkup />
      <AnonouncementMenuMarkup />
    </div>
  );

  return (
    <TopBar
      secondaryMenu={secondaryMenuMarkup}
      showNavigationToggle
      userMenu={userMenuMarkup}
      onNavigationToggle={toggleMobileNavigationActive}
      // logoSuffix={
      //   (width || 0) > 770 ? (
      //     <div
      //       className="text-white"
      //       style={{ cursor: "pointer" }}
      //       onClick={() => {
      //         setOpen(!open);
      //       }}
      //     >
      //       <img
      //         src={open ? "/assets/icons8-double-left-52.png" : "/assets/icons8-double-right-52.png"}
      //         style={{ width: 17 }}
      //         alt=""
      //       />
      //     </div>
      //   ) : undefined
      // }
    />
  );
}
